import { LanguageEnum } from '../enums/global.enum';
import { Language } from '../models/language.model';
import { Alphabet } from '@shared-features/models/alphabet.model';

export class ConfigConstant {
  static VERSION = '3.59.0';
  static APP_TITLE = 'Madar Admin';
  static APP_LANGUAGE_COOKIE_KEY = 'appLang';
  static SMALL_PAGE_SIZE = 10;
  static PAGE_SIZE = 20;
  static LARGE_PAGE_SIZE = 30;
  static CONTRACTS_PAGE_SIZE = 1;
  static INIT_PAGE_INDEX = 1;
  static INIT_PAGE_OFFSET = 0;
  static NOTIFICATION_LIMIT = 10;
  static defaultLatitude = 24.774265;
  static defaultLongitude = 46.738586;
  static defaultSpeedLimit = 70;
  static FILE_MAX_SIZE = 2000000;

  static SAUDI_ARABIA_ISO_CODE = 'SA';
  static APP_NAME = 'Plateform';

  public static NAV_BAR_MENU_OPEN = 'navBarOpen';
  public static DEVICE_OS_TYPE_MAC = 'Mac';
  public static INIT_VALUE = 'Init';
  public static NOT_SUPPORTED = 'NOT_SUPPORTED';
  public static LOGIN_APP = 'CUSTOMER';

  public static LANGUAGES_NAMES: Language[] = [
    new Language('', 'العربية', LanguageEnum.Arabic),
    new Language('', 'English', LanguageEnum.English),
  ];

  public static MEDIA = [
    {
      name: 'facebook.svg',
      link: 'https://www.facebook.com/App.Madar',
    },
    {
      name: 'linkedin.svg',
      link: 'https://www.linkedin.com/company/madar-app',
    },
    {
      name: 'twitter.svg',
      link: 'https://twitter.com/madar_app',
    },
  ];

  public static namesOfMonths = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];

  public static ALL = 'All';
  public static SELECT_ALL = 'Select all';

  public static MOBILE_NUMBER_SEPARATOR = '-';

  // socket
  public static TRACKING_DRIVER_EVENT = 'TRACKING_DRIVER';

  public static TRACKING_CUSTOMER_DRIVER_EVENT = 'TRACKING_CUSTOMER_DRIVER';

  public static TRACKING_SHIPMENT_EVENT = 'TRACKING_SHIPMENT';

  public static TRACKING_ORGANIZATION_DRIVER_EVENT = 'TRACKING_ORGANIZATION_DRIVER';

  public static TRACKING_FLEET_DRIVER_EVENT = 'TRACKING_FLEET_DRIVER';
  static CUSTOMER_SUPPORT_NUMBER = '+966 920017421';
  static CUSTOMER_SUPPORT_EMAIL = 'Support@madarplatform.com';
  static APP_VERSION_KEY = 'VERSION';
  static cloudFlareFLag = 'enable-cloudflare-customer';

  public static Alphabet: Alphabet[] = [
    new Alphabet('أ', 'A'),
    new Alphabet('ا', 'A'),
    new Alphabet('ب', 'B'),
    new Alphabet('ح', 'J'),
    new Alphabet('د', 'D'),
    new Alphabet('ر', 'R'),
    new Alphabet('س', 'S'),
    new Alphabet('ص', 'X'),
    new Alphabet('ط', 'T'),
    new Alphabet('ع', 'E'),
    new Alphabet('ق', 'G'),
    new Alphabet('ك', 'K'),
    new Alphabet('ل', 'L'),
    new Alphabet('م', 'Z'),
    new Alphabet('ن', 'N'),
    new Alphabet('هـ', 'H'),
    new Alphabet('و', 'U'),
    new Alphabet('ي', 'V'),
    new Alphabet('ى', 'V'),
  ];

}
